import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/meta.png")